import { AccountPageTabs } from "~/app/account/[companyId]/constants";
import { MeetingPageTabs } from "~/app/calendar/meetings/[meeting_id]/types/common";
import { ContactPageTabs } from "~/app/contact/[contact_id]/constants";
import { OpportunityPageTabs } from "~/app/opportunity/[opportunity_id]/constants";

import { Service } from "~/components/IntegrationV1/enums";

export const routes = {
  appDefaultLanding: "/sales/opportunities",
  auth: {
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    error: "/auth/callback/error",
    onboarding: "/onboarding",
  },
  home: "/",
  dashboard: "/dashboard",
  reporting: "/reporting",
  redirect: "/redirect",
  notes: "/notes",
  tasks: "/tasks",
  workflows: {
    index: "/workflows",
    detailsPage: (workflow_id: string, subRoute?: string) =>
      `/workflows/${workflow_id}${subRoute ? `/${subRoute}` : ""}`,
  },
  visitors: "/sales/leads",
  leadsApp: "/leads",
  forms: {
    index: "/forms",
    formPage: (form_id: string) => `/forms/${form_id}`,
    edit: (form_id: string) => `/forms/${form_id}/edit`,
    preview: (form_id: string) => `/forms/${form_id}/preview`,
  },
  campaigns: {
    index: "/dashboard/campaigns",
    detailsPage: (campaignId: string) => `/dashboard/campaign/${campaignId}`,
  },
  integrations: "/dashboard/apps",
  meetings: {
    index: "/calendar/meetings",
    detailsPageBase: (meeting_id: string) => `/calendar/meetings/${meeting_id}`,
    detailsPage: (
      meeting_id: string,
      tab: MeetingPageTabs = MeetingPageTabs.NOTE,
    ) => `/calendar/meetings/${meeting_id}?tab=${tab}`,
    settings: "/calendar/meetings/settings",
  },
  salesDashboard: {
    index: "/sales",
  },
  emails: {
    index: "/inbox/emails",
    threadPage: (thread_id: string) => `/inbox/emails/thread/${thread_id}`,
    draft: "/inbox/emails/draft",
    scheduled: "/inbox/emails/scheduled",
  },
  opportunity: {
    index: "/sales/opportunities",
    detailsPageBase: (opportunity_id: string) =>
      `/opportunity/${opportunity_id}`,
    detailsPage: (
      opportunity_id: string,
      subRoute: OpportunityPageTabs = OpportunityPageTabs.ACTIVITY,
    ) => `/opportunity/${opportunity_id}?tab=${subRoute}`,
  },
  contact: {
    index: "/sales/contacts",
    detailsPageBase: (contact_id: string) => `/contact/${contact_id}`,
    detailsPage: (
      contact_id: string,
      subRoute: ContactPageTabs = ContactPageTabs.ACTIVITY,
    ) => `/contact/${contact_id}?tab=${subRoute}`,
  },
  account: {
    index: "/sales/accounts",
    detailsPageBase: (account_id: string) => `/account/${account_id}`,
    detailsPage: (
      account_id: string,
      subRoute: AccountPageTabs = AccountPageTabs.ACTIVITY,
    ) => `/account/${account_id}?tab=${subRoute}`,
  },
  settings: {
    prefix: "/settings",
    index: "/settings/preferences",
    profile: "/settings/profile",
    preferences: "/settings/preferences",
    attributes: "/settings/objects",
    profileSecurity: "/settings/profile/security",
    organization: "/settings/organization",
    organizationMembers: "/settings/organization/members",
    billing: "/settings/billing",
    pipelines: {
      index: "/settings/pipelines",
      edit: (pipeline_id: string) =>
        `/settings/pipelines?pipeline_id=${pipeline_id}`,
    },
    integrations: {
      index: "/settings/integrations",
      detailsPage: (service: Service) => `/settings/integrations/${service}`,
    },
    support: "/settings/support",
  },
  terms: "/terms",
  privacy: "/privacy",
  dashboardSupport: "/settings/support",
  salesApp: {
    index: "/sales",
  },
};

export const authRoutes = [
  routes.auth.signIn,
  routes.auth.signUp,
  routes.auth.forgotPassword,
  routes.auth.resetPassword,
  routes.auth.error,
];

export const publicRoutes = [routes.home, routes.terms, routes.privacy];
export const PRIVATE_ROUTES_START_WITH = [
  routes.salesApp.index,
  "/account",
  "/contact",
  "/opportunity",
  "/admin",
  "/calendar",
  "/inbox",
  "/connect-slack",
  "/connect-stripe",
  routes.dashboard,
  routes.forms.index,
  routes.workflows.index,
  routes.settings.prefix,
];
